import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-3 col-lg-4" }
const _hoisted_3 = { class: "col-xxl-9 col-lg-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SellerOverview = _resolveComponent("SellerOverview")!
  const _component_SellerID = _resolveComponent("SellerID")!
  const _component_RevenueChart = _resolveComponent("RevenueChart")!
  const _component_ProductsList = _resolveComponent("ProductsList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SellerOverview),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SellerID)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RevenueChart)
      ])
    ]),
    _createVNode(_component_ProductsList)
  ]))
}